import Service from "@/services/client";
//import {router} from '@/plugins/router'

export default {
  namespaced: false,
  state: {
    list: {},
    current: {},
  },
  actions: {
    getClients({ dispatch, commit }) {
      Service.get()
        .then((data) => {
          if(data){
            commit("clientList", data.data);
          }
        })
        .catch((err) => {
          //dispatch("alert/error", err, { root: true });
        });
    },
    getClient({ dispatch, commit }, id) {
      Service.getOne(id)
        .then((data) => {
          if(data){
            commit("clientCurrent", data.data);
          }
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    putClient({ dispatch }, payload) {
      Service.put(payload.id, payload.param)
        .then(() => {
          //dispatch("alert/success", "Le client a été modifié");
          dispatch("getClient", payload.id);
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    postClient({ dispatch }, payload) {
      Service.post(payload.param)
        .then(() => {
          //dispatch("alert/success", "Le client a été créé");
          dispatch("getClients");
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    deleteClient({ dispatch }, payload) {
      Service.delete(payload.id)
        .then(() => {
          //dispatch("alert/success", "Le client a été supprimé");
          dispatch("getClients");
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    postCreditCard({ dispatch }, payload) {
      Service.postCard(payload.id, payload.param)
        .then(() => {
          //dispatch("alert/success", "La carte de crédit a été sauvegardé");
          dispatch("getClient", payload.id);
        })
        .catch((err) => {
          dispatch("alert/error", err.response.data, { root: true });
        });
    },
  },
  mutations: {
    clientList(state, list) {
      state.list = list;
    },
    clientCurrent(state, current) {
      state.current = current;
    },
  },
};
